import { type Common } from '../common.js';
import { type FindAllArgs, type FlowRunFleet } from '../models/flow/flowRunFleet.js';

export class API {
  common: Common;
  baseEndpoint = '/flow/fleets';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(queryParams?: FindAllArgs): Promise<FlowRunFleet[]> {
    const url = this.common.constructPath(this.baseEndpoint, queryParams);
    return await this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<FlowRunFleet> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.getJSON(url);
  }
}
